export default "__VITE_ASSET__46179fc4__"